module.exports = __webpack_public_path__ + "img/u7795.bde23de9.png";